
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENVIRONMENT, API } from 'src/app/_constants/app.constants';
import { AuthService } from "../auth/auth.service";
import { DepartmentRoutingResponse } from "src/app/_models/departmentRouting.model";
import { RoutingAPI } from "src/app/_models/user";
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';

import { AppModule } from "src/app/app.module";
import { SharedModule } from "src/app/_components/shared.module";
import { ServiceModule } from 'src/app/_services/service.module';
import { catchError, of } from "rxjs";

@Injectable({
  providedIn: ServiceModule
})
export class DepartmentRoutingService {

  private _departmentRoutingDetails: any = null;
  isHelpRequested: boolean = false;
  activeTraveler = null;
  activeSegment = null;
  showBoardingPass = false;

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private authService: AuthService,
  ) { }

  /**
   *
   * Getter for department route details
   *
  */
  get departmentRoutingDetails(): DepartmentRoutingResponse {
    return this._departmentRoutingDetails ? { ...this._departmentRoutingDetails } : null;
  }

  /**
   *
   * Parses the response and sets it to the service
   *
   * @param pnr
   * @param lastName
   *
   */
  async getDepartmentRoutingDetails(pnr: string, lastName: string, reasonCode: string = '', language: string = '', airportCode: string = '', gate: string = '', assetId: string = '', location: string = ''): Promise<void> {
    // this.logger.debug('DepartmentRoutingService: getDepartmentRoutingDetails()', arguments);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.ROUTING_SEARCH}`;
    let body: RoutingAPI = {
      action: 'GET_DEPARTMENT_ROUTING',
      pnr: pnr,
      lastName: lastName,
      language: language,
      reasonCode: reasonCode,
      airportCode: airportCode,
      geoLocation: gate,
      assetId: assetId,
      currentLocation: location
    }

    let response = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, {
        headers: new HttpHeaders({
          'Hostname': this.authService.getHostName(),
          'Xsrf': this.authService.token
        })
      }).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    // await this.http.post(encodeURI(url), body, {
    //   headers: new HttpHeaders({
    //     'Hostname': this.authService.getHostName(),
    //     'Xsrf': this.authService.token
    //   })
    // }).toPromise();

    if (response["success"]) {
      this.setDepartmentRoutingDetails(response["data"]);
    } else {
      this.setDepartmentRoutingDetails();
      throw response;
    }
  }

  /**
   *
   * Parses the response and sets it to the service
   *
   * @param departmentRoutingDetails - missing interface for type
   *
   */
  setDepartmentRoutingDetails(departmentRoutingDetails: DepartmentRoutingResponse = null): void {
    this.logger.debug('DepartmentRoutingService: setDepartmentRoutingDetails()', this);
    this._departmentRoutingDetails = departmentRoutingDetails;
  }

}
